import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { getFullUrl } from "../../../shared/utils/url";
import { HierarchyRootObjectsResponse } from "../models/response/hierarchy-root-objects-response.model";
import { HierarchyObjectsResponse } from "../models/response/hierarchy-objects-response.model";
import { HierarchyTypesResponse } from "../models/response/hierarchy-types-response.model";
import { CookieService } from 'ngx-cookie';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HierarchyService {

  constructor(
    private http: HttpClient,
    private cookieservice: CookieService
  ) { }

  getHierarchyTypes(): Observable<HierarchyTypesResponse> {
    const fullUrl = getFullUrl(environment.guiBackendRootEndpoint, 'hierarchy-types');
    return this.http.get<HierarchyTypesResponse>(fullUrl, {
      params: {
        language: this.cookieservice.get('lang')!
      }
    });
  }

  getHierarchyRootObjectsByTypeId(hierarchyTypeId: number): Observable<HierarchyRootObjectsResponse> {
    const fullUrl = getFullUrl(environment.guiBackendRootEndpoint, 'hierarchy-root-objects');
    return this.http.get<HierarchyRootObjectsResponse>(fullUrl, {
      params: {
        language: this.cookieservice.get('lang')!,
        hierarchyTypeId: hierarchyTypeId,
      }
    });
  }

  getHierarchyObjectsByRootId(hierarchyTypeId: number, hierarchyRootObjectId: number): Observable<HierarchyObjectsResponse> {
    const fullUrl = getFullUrl(environment.guiBackendRootEndpoint, 'hierarchy-objects');
    return this.http.get<HierarchyObjectsResponse>(fullUrl, {
      params: {
        hierarchyTypeId: hierarchyTypeId,
        hierarchyRootObjectId: hierarchyRootObjectId,
        language: this.cookieservice.get('lang')!
      }
    });
  }
}
